import { routing, type AppLocale } from "@/i18n/routing";

export function toTagSlug(tag: string): string {
  return encodeURIComponent(tag.toLowerCase());
}

function localePrefix(locale: AppLocale): string {
  return locale === routing.defaultLocale ? "" : `/${locale}`;
}

function articlesSegment(locale: AppLocale): string {
  return locale === "sv" ? "/artiklar" : "/articles";
}

export function getArticleHref(slug: string, locale: AppLocale): string {
  return `${localePrefix(locale)}${articlesSegment(locale)}/${slug}`;
}

export function getTagHref(tag: string, locale: AppLocale): string {
  return `${localePrefix(locale)}${articlesSegment(locale)}/tag/${toTagSlug(tag)}`;
}
